// Layout Types
import { DefaultLayout } from "./layouts";
import withStorage from "./components/common/WithStorage";
// Route Views
import BlogOverview from "./views/BlogOverview";
import Education from "./views/Education";
import Cms from "./views/Cms";
import Alerts from "./views/Alerts";
import Faq from "./views/Faq";
import FourYear from "./views/FourYear";
import MemberBlogOverview from "./views/MemberBlogOverview";
import Profile from "./views/Profile";
import AddNewPost from "./views/AddNewPost";
import Errors from "./views/Errors";
import PostPage from "./views/Post";
import Success from "./views/Success";
import Analyst from "./views/Analyst";
import Analysts from "./views/Analysts";
import SignupLayout from "./layouts/SignupLayout";
import Login from "./views/Login";
import Forgot from "./views/Forgot";
import Register from "./views/Register";
import Prices from "./views/Prices";
import Terms from "./views/Terms";
import Newsale from "./views/Newsale";
import Policy from "./views/Policy";
import SearchResults from "./views/SearchResults";
import LandingPage from "./views/LandingPage";
import NFTPage from "./views/NFTPage";

export default [
  {
    path: "/login",
    layout: SignupLayout,
    component: Login,
  },
  {
    path: "/",
    layout: LandingPage,
    component: LandingPage,
  },
  {
    path: "/forgot",
    layout: SignupLayout,
    component: Forgot,
  },
  {
    path: "/success",
    layout: SignupLayout,
    component: Success,
  },
  {
    path: "/register",
    layout: SignupLayout,
    component: Register,
  },
  {
    path: "/terms&conditions",
    // layout: SignupLayout,
    layout: DefaultLayout,
    component: Terms,
  },
  {
    path: "/sale",
    layout: SignupLayout,
    component: Newsale,
  },
  {
    path: "/policy",
    // layout: SignupLayout,
    layout: DefaultLayout,
    component: Policy,
  },
  {
    path: "/prices",
    layout: SignupLayout,
    component: Prices,
  },
  {
    path: "/couponcheckout",
    layout: SignupLayout,
    component: Prices,
  },
  {
    path: "/blogs/public",
    layout: DefaultLayout,
    component: withStorage(BlogOverview),
  },
  {
    path: "/search",
    layout: DefaultLayout,
    component: withStorage(SearchResults),
  },
  {
    path: "/blogs/premium/",
    layout: DefaultLayout,
    component: MemberBlogOverview,
  },
  {
    path: "/video/:postName",
    layout: DefaultLayout,
    component: PostPage,
  },
  {
    path: "/blog/:postName",
    layout: DefaultLayout,
    component: PostPage,
  },
  {
    path: "/blogs/public/:postName",
    layout: DefaultLayout,
    component: PostPage,
  },
  {
    path: "/analyst/:id",
    layout: DefaultLayout,
    component: Analyst,
  },
  {
    path: "/analysts",
    layout: DefaultLayout,
    component: Analysts,
  },
  {
    path: "/education",
    layout: DefaultLayout,
    component: Education,
  },
  {
    path: "/alerts",
    layout: DefaultLayout,
    component: Alerts,
  },
  {
    path: "/faq",
    layout: DefaultLayout,
    component: Faq,
  },
  {
    path: "/4yearcycle",
    layout: DefaultLayout,
    component: FourYear,
  },
  {
    path: "/alerts/:id",
    layout: DefaultLayout,
    component: Alerts,
  },
  {
    path: "/user-profile",
    layout: DefaultLayout,
    component: Profile,
  },
  {
    path: "/user-profile/connectWallet",
    layout: DefaultLayout,
    component: Profile,
  },
  {
    path: "/add-new-post",
    layout: DefaultLayout,
    component: withStorage(AddNewPost),
  },
  {
    path: "/edit-post/:postId",
    layout: DefaultLayout,
    component: withStorage(AddNewPost),
  },
  {
    path: "/errors",
    layout: DefaultLayout,
    component: Errors,
  },
  {
    path: "/cms",
    layout: DefaultLayout,
    component: Cms,
  },
  {
    path: "/NFT",
    layout: SignupLayout,
    component: Register,
  },
];
